import { useTranslation } from "react-i18next";
import { Table } from "@/features/Table";

import { useBankPositionsColumns } from "./columns";
import { client, table_name, type BankPositionRow, type FilterSchema } from "./config";
import { FilterBankPositions } from "./filter";

export function BankPositionsTable() {
  const { t } = useTranslation("tables");
  const columns = useBankPositionsColumns();

  return (
    <Table<BankPositionRow, FilterSchema>
      label={t(`${table_name}.title`, { defaultValue: "Bank Positions" })}
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<FilterBankPositions />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
}
